import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Drawer from "@mui/material/Drawer";
import { Typography, useMediaQuery, Menu, MenuItem, Button } from "@mui/material";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { get_user_plan } from "../Api service/APIvariables";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import SnackBar from "../Components/SnackBar";

// icons
import { FaUserEdit } from "react-icons/fa";
import { BiSolidMessageRoundedDetail } from "react-icons/bi";
import { IoMdNotifications } from "react-icons/io";
import { FaFileInvoice } from "react-icons/fa6";
import { MdAttachEmail } from "react-icons/md";
import { TbProgressCheck } from "react-icons/tb";
import { LuHardDriveUpload } from "react-icons/lu";
import { PiDatabaseFill } from "react-icons/pi";
import WidgetsRoundedIcon from "@mui/icons-material/WidgetsRounded";
import HouseRoundedIcon from "@mui/icons-material/HouseRounded";
import { flexbox } from "@mui/system";
import mdqLogo from "../assets/mdqlogo.jpeg";
import Notification from "../pages/Notification";

// SideBar Card
const SidebarCard = styled(Box)(({ theme }) => ({
  width: "220px",
  minHeight: "90vh",
  backgroundColor: "#fff",
  borderRadius: "10px",
  // border: "1px solid #eoeoeo",
  border: "1px solid #CFD8DC",
  paddingTop: 0,
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  position: "fixed",
  left: theme.spacing(2),
  top: theme.spacing(2),
  zIndex: 10,
}));

export default function UserLayout({
  successOpen,
  setsuccessOpen,
  successMessage,
  setsuccessMessage,
  successStatus,
  setsuccessStatus,
  successColor,
  setsuccessColor,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  
  // Calculate active page based on pathname
  let activePage = "";
  if (location.pathname === "/") activePage = "";
  else if (location.pathname.startsWith("/template")) activePage = "template";
  else if (location.pathname.startsWith("/fillers")) activePage = "fillers";
  else if (location.pathname.startsWith("/status")) activePage = "status";
  else if (location.pathname.startsWith("/upload-card")) activePage = "upload-card";
  else if (location.pathname.startsWith("/card-data")) activePage = "card-data";
  else if (location.pathname.startsWith("/profile")) activePage = "profile";
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const openProfileMenu = Boolean(anchorEl);
  const [isOpen, setIsOpen] = React.useState(false);
  const [iconPosition, setIconPosition] = React.useState({ top: 0, left: 0 });
  const iconRef = React.useRef(null);

  const navigate = useNavigate();
  const [userPlan, setUserPlan] = React.useState(null);

  React.useEffect(() => {
    const fetchPlan = async () => {
      try {
        const user_id = localStorage.getItem("user_id");
        const token = localStorage.getItem("auth_token");
        if (!user_id || !token) return;

        const formData = new FormData();
        formData.append("user_id", user_id);

        const res = await fetch(get_user_plan, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
        const data = await res.json();
        if (!data.error) {
          setUserPlan(data);
        }
      } catch (err) {}
    };
    fetchPlan();

    window.addEventListener("planUpdated", fetchPlan);
    return () => {
      window.removeEventListener("planUpdated", fetchPlan);
    };
  }, [location.pathname]); // refetch on navigation

  const getBadgeColor = (plan_id) => {
    switch(parseInt(plan_id)) {
      case 2: return "#1976d2"; // Plus (Blue)
      case 3: return "#9c27b0"; // Pro (Purple)
      case 4: return "#fbc02d"; // Unlimited (Gold)
      default: return "#757575"; // Free (Gray)
    }
  };
  // logout
  const handleLogOut = () => {
    localStorage.clear();
    navigate("/login");
  };

  // Utility function to style the SVG icons
  // const getIconStyles = (active, isHovering) => {
  //   return {
  //     width: "17px",
  //     height: "17px",
  //     transition: "filter 0.3s",
  //     filter: active
  //       ? "invert(100%)" // Active state (white color)
  //       : isHovering
  //         ? "invert(50%)" // Hover state (darker color)
  //         : "invert(30%)", // Default state (gray color)
  //   };
  // };

  const menuItems = [
    {
      text: "Home",
      icon: <HouseRoundedIcon sx={{ fontSize: "20px" }} />,
      page: "",
    },
    {
      text: "Template",
      icon: <FaFileInvoice />,
      page: "template",
    },
    {
      text: "Fillers",
      icon: <TbProgressCheck />,
      page: "fillers",
    },

    {
      text: "Status",
      icon: <MdAttachEmail />,
      page: "status",
    },
    {
      text: "Upload Card",
      icon: <LuHardDriveUpload />,
      page: "upload-card",
    },
    {
      text: "Card Data",
      icon: <PiDatabaseFill />,
      page: "card-data",
    },
  ];

  const handleMenuItemClick = (page) => {
    navigate(page ? `/${page}` : `/`);
    setMobileMenuOpen(false);
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
    navigate(`/profile`);
  };

  const handleOpenNotification = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect(); // Get position of icon
      setIconPosition({ top: rect.bottom, left: rect.right });
    }
    setIsOpen(true);
  };

  const handleCloseNotification = () => {
    setIsOpen(false);
  };

  return (
    <div
      className="dashboard"
      style={{
        padding: 0,
        margin: 0,
        top: 0,
        left: 0,
        height: "100vh",
        // minHeight: "100%",
        width: "100%",
        position: "relative",
        // fontFamily: "Roboto, sans-serif",
        backgroundColor: "#eceff1",
        overflow: "hidden",
      }}
    >
      <SnackBar
        open={successOpen}
        message={successMessage}
        setOpen={setsuccessOpen}
        status={successStatus}
        color={successColor}
      />

      <CssBaseline />

      <Box sx={{ display: "flex", height: "100%" }}>
        {/* Sidebar for Desktop */}
        {!isMobile && (
          <SidebarCard>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "30px",
                padding: "10px 0",
              }}
            >
              <img
                src={mdqLogo}
                alt="MDQ Logo"
                style={{
                  // display: "block",
                  height: "15%",
                  width: "15%",
                  // marginBottom: "20px",
                  // justifyContent: "flex-start",
                  // alignItems: "center",
                  // alignContent: "center",
                  // marginLeft: "auto",
                  // marginRight: "auto",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "#212121",
                  textAlign: "center",
                }}
              >
                QuickCard
              </Typography>
            </Box>

            <List>
              {menuItems.map((item, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton
                    onClick={() => handleMenuItemClick(item.page)}
                    sx={{
                      padding: "4px 10px",
                      borderRadius: "8px",
                      marginBottom: "6px",
                      backgroundColor:
                        activePage === item.page ? "#453c72" : "transparent",
                      color: activePage === item.page ? "white" : "gray",
                      boxShadow:
                        activePage === item.page
                          ? "0 4px 8px rgb(69,60,114)"
                          : "none",
                      "&:hover": {
                        backgroundColor:
                          activePage === item.page ? "#453c72" : "#d6dfff",
                        color: activePage === item.page ? "white" : "black",
                      },
                      // "&:hover .MuiListItemIcon-root": {
                      //   color: activePage === item.page ? "white" : "black",
                      // },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: activePage === item.page ? "white" : "#607d8b",
                        minWidth: "36px",
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color:
                              activePage === item.page ? "white" : "#607d8b",
                          }}
                        >
                          {item.text}
                        </Typography>
                      }
                      sx={{
                        fontWeight: "bold",
                        color: activePage === item.page ? "white" : "#607d8b",
                        // fontWeight: 600,
                      }}
                      primaryTypographyProps={{
                        fontSize: "14px", // Adjust font size here
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          
            <Box sx={{ mt: 'auto', p: 2, borderTop: '1px solid #e0e0e0' }}>
              <Box 
                onClick={handleProfileClick}
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 1.5,
                  p: 1, 
                  borderRadius: 2, 
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                }}
              >
                <Box sx={{ 
                  width: 32, 
                  height: 32, 
                  borderRadius: '50%', 
                  backgroundColor: '#453c72',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  ml: 0.5,
                  boxShadow: `0 0 0 2px #ffffff, 0 0 0 4px ${userPlan ? getBadgeColor(userPlan.plan_id) : '#757575'}`,
                  transition: 'all 0.3s ease'
                }}>
                  {(userPlan?.user_name || localStorage.getItem("user_name") || "U")[0].toUpperCase()}
                </Box>
                <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {userPlan?.user_name || localStorage.getItem("user_name") || "User"}
                  </Typography>
                  {userPlan ? (
                    <Typography variant="caption" sx={{ color: getBadgeColor(userPlan.plan_id), fontWeight: 'bold' }}>
                      {userPlan.plan_name ? userPlan.plan_name.toUpperCase() : 'FREE'}
                    </Typography>
                  ) : (
                    <Typography variant="caption" color="textSecondary">Loading...</Typography>
                  )}
                </Box>
              </Box>

              <Menu
                anchorEl={anchorEl}
                open={openProfileMenu}
                onClose={handleProfileClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "bottom", horizontal: "right" }}
                sx={{ mt: -6, ml: 2 }}
              >
                <Box sx={{ px: 2, py: 1, minWidth: '200px' }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {userPlan?.user_name || localStorage.getItem("user_name") || "User"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" noWrap>
                    {userPlan?.user_email || localStorage.getItem("user_email") || ""}
                  </Typography>
                  
                  {userPlan && (
                    <Box sx={{ mt: 1.5, mb: 1 }}>
                      <Box sx={{ 
                        display: 'inline-block', 
                        px: 1, 
                        py: 0.5, 
                        borderRadius: 1, 
                        backgroundColor: getBadgeColor(userPlan.plan_id),
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '0.75rem',
                        letterSpacing: 1
                      }}>
                        {userPlan.plan_name ? userPlan.plan_name.toUpperCase() : 'FREE'}
                      </Box>
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="caption" display="block">Cards: {userPlan.card_limit === 999999 ? 'Unlimited' : userPlan.card_limit}</Typography>
                        <Typography variant="caption" display="block">Emails: {userPlan.email_limit === 999999 ? 'Unlimited' : userPlan.email_limit}</Typography>
                      </Box>
                    </Box>
                  )}
                  
                  <Button 
                    variant="outlined" 
                    size="small" 
                    fullWidth 
                    sx={{ mt: 1, mb: 1, textTransform: 'none' }}
                    onClick={() => { setAnchorEl(null); navigate("/subscription"); }}
                  >
                    Upgrade Plan
                  </Button>
                </Box>
                <MenuItem onClick={handleProfileClose}>My profile</MenuItem>
                <MenuItem onClick={handleLogOut}>Logout</MenuItem>
              </Menu>
            </Box>
</SidebarCard>
        )}

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            marginLeft: isMobile ? 0 : "225px",
            padding: 0,
            paddingTop: 0,
            height: "100vh",
            overflowY: "auto",
            paddingBottom: isMobile ? "80px" : "20px",
          }}
        >
          {/* Main Header --> Page Render, notification, message, profile icons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: isMobile ? "20px" : "10px",
              paddingTop: 2,
              paddingLeft: isMobile ? "20px" : 3.4,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#453c72" }}>
              {activePage ? activePage.replace("-", " ").replace(/\b\w/g, l => l.toUpperCase()) : "Dashboard"}
            </Typography>

            {/* Icons */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton
                onClick={handleOpenNotification} // Clicking icon opens notification
                sx={{ color: "#607d8b", display: "flex", alignItems: "center" }}
              >
                <IoMdNotifications
                  // src={notificationIcon}

                  style={{
                    width: "18px",
                    height: "18px",
                    backgroundColor: "transparent",
                  }}
                />
              </IconButton>
              <IconButton
                sx={{ color: "#607d8b", display: "flex", alignItems: "center" }}
              >
                <BiSolidMessageRoundedDetail
                  // src={messageIcon}
                  style={{
                    width: "18px",
                    height: "18px",
                    backgroundColor: "transparent",
                  }}
                />
              </IconButton>
              
              
            </Box>
          </Box>

          <Box
            sx={{
              padding: 1,
              borderRadius: "8px",
              paddingRight: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Outlet context={{ setActivePage: (p) => navigate(p ? `/${p === 'Dashboard' ? '' : p.toLowerCase().replace(" ", "-")}` : `/`) }} />
          </Box>
        </Box>
      </Box>

      {/* Mobile View */}
      {isMobile && (
        <>
          <BottomNavigation
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              // borderRadius: "20px",
            }}
          >
            <BottomNavigationAction
              label="Dashboard"
              icon={<HouseRoundedIcon style={{ fill: "#607d8b" }} />}
              onClick={() => handleMenuItemClick("")}
            />
            <BottomNavigationAction
              label="Card Data"
              icon={
                <PiDatabaseFill
                  style={{
                    width: "19px",
                    height: "19px",
                    backgroundColor: "transparent",
                    fill: "#607d8b",
                  }}
                />
              }
              onClick={() => handleMenuItemClick("card-data")}
            />
            <BottomNavigationAction
              label="Menu"
              icon={<WidgetsRoundedIcon sx={{ color: "#607d8b" }} />}
              onClick={() => setMobileMenuOpen(true)}
            />
          </BottomNavigation>
          <Drawer
            anchor="left"
            open={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
          >
            <Box sx={{ width: 250, display: 'flex', flexDirection: 'column', height: '100%', padding: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                  padding: "10px 0",
                }}
              >
                <img
                  src={mdqLogo}
                  alt="MDQ Logo"
                  style={{
                    display: "flex",
                    height: "15%",
                    width: "15%",
                    // marginBottom: "20px",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    alignContent: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#212121",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  QuickCard
                </Typography>
              </Box>
              <List>
                {menuItems.map((item, index) => (
                  <ListItem key={index}>
                    <ListItemButton
                      onClick={() => handleMenuItemClick(item.page)}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.text} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
              <Box sx={{ mt: 'auto', p: 2, borderTop: '1px solid #e0e0e0' }}>
                <Box 
                  onClick={handleProfileClick}
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 1.5,
                    p: 1, 
                    borderRadius: 2, 
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                  }}
                >
                  <Box sx={{ 
                    width: 32, 
                    height: 32, 
                    borderRadius: '50%', 
                    backgroundColor: '#453c72',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}>
                    {(userPlan?.user_name || localStorage.getItem("user_name") || "U")[0].toUpperCase()}
                  </Box>
                  <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {userPlan?.user_name || localStorage.getItem("user_name") || "User"}
                    </Typography>
                    {userPlan ? (
                      <Typography variant="caption" sx={{ color: getBadgeColor(userPlan.plan_id), fontWeight: 'bold' }}>
                        {userPlan.plan_name ? userPlan.plan_name.toUpperCase() : 'FREE'}
                      </Typography>
                    ) : (
                      <Typography variant="caption" color="textSecondary">Loading...</Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Drawer>
        </>
      )}

      {/* Notification Box */}
      <Notification
        isOpen={isOpen}
        onClose={handleCloseNotification}
        position={iconPosition}
      />
    </div>
  );
}
